import { useCallback } from 'react'
import { useIntl } from 'react-intl'
import ClickableListItem from 'LuxKit/List/ClickableListItem'
import BodyText from 'LuxKit/Typography/BodyText'
import type { ChatSearchHighlight, ChatSearchHit } from 'tripPlanner/api/types'
import { getCompactRecentChatTimestampLabel } from 'tripPlanner/assistant/utils/compactChatTimestamp'
import { highlightChatSearchMatches } from './chatSearchHighlight'
import { getRecentItemDisplayTitle } from './recentChatItems'

const NO_HIGHLIGHTS: ReadonlyArray<ChatSearchHighlight> = []

interface Props {
  hit: ChatSearchHit
  onSelect: (chatId: number) => void
}

function TripPlannerChatSearchResultRow({ hit, onSelect }: Props) {
  const intl = useIntl()
  const title = getRecentItemDisplayTitle(intl, hit.title)
  // The highlight offsets index the raw title, so only the Untitled fallback replaces it.
  const titleContent = hit.title.trim() ? highlightChatSearchMatches(hit.title, hit.titleHighlights) : title
  const label = intl.formatList(hit.snippet ? [title, hit.snippet] : [title], { type: 'unit' })

  const handleClick = useCallback(() => {
    onSelect(hit.chatId)
  }, [hit.chatId, onSelect])

  return (
    <ClickableListItem
      size="medium"
      title={titleContent}
      titleLineClamp={1}
      subtitle={hit.snippet && highlightChatSearchMatches(hit.snippet, hit.snippetHighlights ?? NO_HIGHLIGHTS)}
      subtitleLineClamp={1}
      aria-label={label}
      onClick={handleClick}
    >
      <BodyText variant="small" colour="light-foreground-alt" wrap="no-wrap">
        {getCompactRecentChatTimestampLabel(hit.updatedAt, intl)}
      </BodyText>
    </ClickableListItem>
  )
}

export default TripPlannerChatSearchResultRow
